<template>
  <div id="app">
    <div id="overlay-common" />
    <component :is="this.$route.meta.layout || 'LayoutDefault'">
      <router-view />
    </component>
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
    title: CODE_EDITOR.VUE_TITLE,
    meta: [
      {
        name: "description",
        content: CODE_EDITOR.VUE_TITLE,
      },
    ],
  },
  components: {
    LayoutDefault: () => import('@/layouts/Default')
  },
  data() {
    return {}
  },
  created() {
    this.checkBrowser();
  },
  methods: {
    checkBrowser() {
      // Firefox 1.0+
      const isFirefox = typeof InstallTrigger !== "undefined";
      if (isFirefox) {
        document.body.classList.add("firefox_css");
      }
      else {
        
        document.body.classList.remove("firefox_css");
      }
      const isSafari =
        /constructor/i.test(window.HTMLElement) ||
        (function (p) {
          return p.toString() === "[object SafariRemoteNotification]";
        })(!window["safari"] || safari.pushNotification);
      if (isSafari) {
        document.body.classList.add("Safari_css");
      }
      else {
        document.body.classList.remove("Safari_css");
      }
    },
    syncVanBanTuTruc() {
      this.$store.dispatch("vanBanDen/syncVanBanTuTruc");
    },
  },
};
</script>

<style lang="scss">
@import "assets/css/base/index.scss";
html,
body {
  font-family: "Segoe UI", "Segoe UI Web (West European)", Arial, "Roboto", "Inter",  sans-serif;
  font-size: 12px;
}

#app {
  font-family: "Segoe UI", "Segoe UI Web (West European)", Arial, "Roboto", "Inter",  sans-serif;
  color: #344061;
}
</style>
